export default __webpack_public_path__ + "static/media/Pyramide-besoins_pro_n5_accomplissement.4c05b3d8.svg";